import React, { useEffect, useState } from 'react';
import { Route, Router, Switch, Redirect } from 'react-router-dom';
import { authenticationService } from './services/AuthenticationService';
import Login from './views/default/Recommend/Login';
import Main from './views/default/Main';
import { history } from './utils/history';
// CRA4/webpack4: default ESM uses class fields; legacy CJS is transpiled for older Babel.
import { useIdleTimer } from 'react-idle-timer/dist/index.legacy.cjs.js';
import NotFound from './views/Error/NotFound';
import './App.css';
import './app_rtl.css';
import NavbarComponent from './components/single_components/NavbarComponent';
import ResetPassword from './views/default/Recommend/ResetPassword';
import Login2FA from './views/default/Recommend/Login2FA';
import CreatePassword from './views/default/Recommend/CreatePassword';
import ApprovingClinicReg from './views/default/Approving/ApprovingClinicReg';
import Patient from './views/doctor/Patient';
import PatientVisit from './views/doctor/PatientVisit';
import PatientSelfOnBoard from './views/Patient/PatientSelfOnBoard';
import Login_Leumit from './views/default/Approving/LoginPain';
import PainCreatePassword from './views/default/Approving/PainCreatePassword';
import PainPatientSelfOnBoard from './views/PainPatientView/PainPatientSelfOnBoard';
import PainResetPassword from './views/default/Approving/PainResetPassword';
import PainLogin2FA from './views/default/Approving/PainLogin2FA';
import LeumitPatientRequests from './views/doctor/LeumitPatientRequests';
import PatientRequest from './views/doctor/PainPatientsRequests/PatientRequest';
import LeumitPayment from './components/Leumit_Patient_SelfOnboard/LeumitPayment';
import LoginPainReg from './views/default/Approving/LoginPainReg';
import LoginPainID from './views/default/Approving/LoginPainID';
import RoutePatientToDashboard from './views/default/Approving/RoutePatientToDashboard';
import Patient2FA from './views/default/Approving/PainPatient2FA';
import LeumitRequestIsSent from './components/Leumit_Patient_SelfOnboard/LeumitRequestIsSent';
import PatientDailyReport from './views/default/PatientDailyReport';
import RecommendClinicReg from './views/default/Recommend/RecommendClinicReg';
import { appendIchilovQuery } from './utils/routeUtils';

const App = () => {
    const [currentUser, setCurrentUser] = useState(null);

    useEffect(() => {
        const subscription = authenticationService.currentUser.subscribe((x) => {
            setCurrentUser(x);
        });

        // Redirecting logic from the componentDidMount lifecycle
        if (!history.location.pathname.includes('pain_patientRoute')) {
            if (!history.location.pathname.toLowerCase().includes('pain')) {
                history.push('/login');
            } else {
                history.push(appendIchilovQuery('/register_pain'));
            }
        }

        // Clean up subscription when component unmounts
        return () => subscription.unsubscribe();
    }, []);

    const handleLogout = async () => {
        await authenticationService.logout();
        if (!history.location.pathname.toLowerCase().includes('pain')) {
            history.push('/login');
        } else {
            history.push(appendIchilovQuery('/login_pain'));
        }
    };

    useIdleTimer({
        timeout: 3600000,
        onIdle: handleLogout,
        onActive: () => console.log(false),
    });

    return (
        <Router history={history}>
            <div className="sade-app-container">
                {currentUser && (
                    <>
                        <NavbarComponent currentUser={currentUser} />
                        <div className="width-separator" />
                    </>
                )}
                <Switch>
                    <Route path="/dashboard/Patient*" component={Patient} />
                    <Route path="/PatientSelfOnboard*" component={PatientSelfOnBoard} />
                    <Route path="/pain_patient_self_onboard*" component={PainPatientSelfOnBoard} />
                    <Route path="/dashboard/PatientOnboard*" component={PatientVisit} />
                    <Route path="/pain_patientRequest**" component={PatientRequest} />
                    <Route path="/dashboard*" component={Main} />
                    <Route path="/pain_requests_dashboard*" component={LeumitPatientRequests} />
                    <Route path="/login" component={Login} />
                    <Route path="/login_pain*" component={Login_Leumit} />
                    <Route path="/2FA*" component={Login2FA} />
                    <Route path="/pain_patient_2FA*" component={Patient2FA} />
                    <Route path="/pain_2FA*" component={PainLogin2FA} />
                    <Route path="/pain_create_password*" component={PainCreatePassword} />
                    <Route path="/pain_patient_login*" component={LoginPainID} />
                    <Route path="/create-password*" component={CreatePassword} />
                    <Route path="/ResetPassword*" component={ResetPassword} />
                    <Route path="/pain_reset_password*" component={PainResetPassword} />
                    <Route path="/register_recommend*" component={RecommendClinicReg} />
                    <Route path="/register_pain*" component={ApprovingClinicReg} />
                    <Route path="/login_pain_reg*" component={LoginPainReg} />
                    <Route path="/national_pain_management_RequestPayment*" component={LeumitPayment} />
                    <Route path="/national_pain_management_Request_Sent*" component={LeumitRequestIsSent} />
                    <Route path="/pain_patientRoute*" component={RoutePatientToDashboard} />
                    <Route path="/national_pain_management_dailyReport*" component={PatientDailyReport} />
                    <Route path="/NotFound*" component={NotFound} />
                    <Redirect to="/NotFound" />
                </Switch>
            </div>
        </Router>
    );
};

export default App;
